module.exports = __webpack_public_path__ + "static/media/dinnings_thumb.745ba548.jpg";